export default __webpack_public_path__ + "2a5d7d7bb5707a637dcd98f2c4225823.png";